/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class MyReportController implements angular.IController {
        public filters: ModelFilterViewModel;
        public fileToken: string;
        public features: CompanyFeatureList;
        public totalResultCount: number;
        $onInit = () => { };

        constructor(private $scope: ng.IScope,
            private buildingService: BuildingService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $rootScope: ng.IRootScopeService,
            private fileService: FileService,
            private $window: ng.IWindowService,
            private organizationSettingsService: OrganizationSettingsService
        ) {
            this.filters = this.buildingService.getFilters();
            this.fileService.getFileToken().then((t) => vm.fileToken = t);

            var vm = this;
            this.$rootScope.$on('filter-change', () => {
                vm.filters = buildingService.getFilters();
                vm.filters.indoorBuildingPartType.groupBy = vm.features.includeIndoorData();
                vm.filters.category.groupBy = vm.features.includeOutdoorData();
                vm.filters.simFamilyTypeName.groupBy = vm.features.includeSimData();
            });

            $window.addEventListener('scroll', () => {
                if ($('md-content').scrollTop() + window.innerHeight > $('#wrapper').height() - 280) {
                    vm.$rootScope.$broadcast("floorplanLoadMore", 1);
                }
            }, true);

            organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => {
                vm.features = features;
                vm.filters.indoorBuildingPartType.groupBy = vm.features.includeIndoorData();
                vm.filters.category.groupBy = vm.features.includeOutdoorData();
                vm.filters.simFamilyTypeName.groupBy = vm.features.includeSimData();
            });
        }
    }

    MyReportController.$inject = ['$scope', 'BuildingService', '$q', '$timeout', '$rootScope', 'FileService', '$window', 'OrganizationSettingsService'];

    angular
        .module('eseebase')
        .controller('MyReportController', MyReportController);
}
